import { Outlet } from "react-router-dom";
import { TopBar } from "./TopBar";
import { LeftNav } from "./LeftNav";
import { RightRail } from "./RightRail";
import { useAppStore } from "../../state/useAppStore";

export function AppShell() {
  const railCollapsed = useAppStore((s) => s.railCollapsed);
  const navCollapsed = useAppStore((s) => s.navCollapsed);
  const cls = [
    "app",
    "font-geist",
    railCollapsed && "rail-collapsed",
    navCollapsed && "nav-collapsed",
  ].filter(Boolean).join(" ");
  return (
    <div
      className={cls}
      data-testid="appshell"
    >
      <TopBar />
      <LeftNav />
      <main className="main">
        <Outlet />
      </main>
      <RightRail />
    </div>
  );
}
